export const TAB_1_WIDTH = 240;

export const TAB_2_WIDTH = 290;

export const TAB_3_WIDTH = 500;

// todo(me): build out types here
export const POSITION_ARCHIVING_SOON = "POSITION-ARCHIVING-SOON";
export const POSITION_ARCHIVED = "POSITION-ARCHIVED";
export const AGENCY_INCENTIVE_ADDED = "AGENCY-INCENTIVE-ADDED";
export const AGENCY_INCENTIVE_UPDATED = "AGENCY-INCENTIVE-UPDATED";
export const AGENCY_INCENTIVE_REMOVED = "AGENCY-INCENTIVE-REMOVED";
